import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

// "Back to home" for the sign in and sign up pages: always visible in the top left corner,
// so a visitor who came here by mistake (or changed their mind) is never stuck on the form.
function BackToHome() {
  const navigate = useNavigate();
  return (
    <Box
      component="a"
      href="/"
      onClick={(e) => {
        e.preventDefault();
        navigate("/");
      }}
      aria-label="Back to home page"
      sx={{
        position: "absolute",
        top: { xs: 12, sm: 20 },
        left: { xs: 12, sm: 24 },
        zIndex: 5,
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.75,
        py: 0.75,
        borderRadius: "999px",
        textDecoration: "none",
        fontFamily: "Rubik, sans-serif",
        fontSize: "13.5px",
        fontWeight: 600,
        color: "#f4e9c9",
        background: "rgba(255,255,255,0.10)",
        border: "1px solid rgba(244,233,201,0.35)",
        backdropFilter: "blur(6px)",
        cursor: "pointer",
        transition: "all .2s ease",
        "&:hover": { background: "rgba(200,160,84,0.28)", borderColor: "#C8A054", color: "#fff", transform: "translateX(-2px)" },
        "&:focus-visible": { outline: "2px solid #C8A054", outlineOffset: 2 },
      }}
    >
      <ArrowBackIcon sx={{ fontSize: 17 }} />
      Back to home
    </Box>
  );
}

export default BackToHome;
